var map = {
	"./audio-placeholder": 670,
	"./audio-placeholder.png": 670,
	"./avatar-missing": 566,
	"./avatar-missing.png": 566,
	"./avatar-missing.svg": 837,
	"./halloween/clouds": 671,
	"./halloween/clouds.png": 671,
	"./halloween/halloween-emblem": 681,
	"./halloween/halloween-emblem.svg": 681,
	"./halloween/spider": 682,
	"./halloween/spider.svg": 682,
	"./halloween/spiderweb": 683,
	"./halloween/spiderweb.svg": 683,
	"./halloween/starfield": 684,
	"./halloween/starfield.png": 684,
	"./halloween/twinkle": 685,
	"./halloween/twinkle.svg": 685,
	"./header-missing": 580,
	"./header-missing.png": 580,
	"./soapbox-logo": 581,
	"./soapbox-logo-white": 582,
	"./soapbox-logo-white.svg": 582,
	"./soapbox-logo.svg": 581,
	"./sprite-post-functions": 686,
	"./sprite-post-functions.png": 686,
	"./video-placeholder": 687,
	"./video-placeholder.png": 687,
	"./void": 688,
	"./void.png": 688,
	"./web-push/web-push-icon_expand": 782,
	"./web-push/web-push-icon_expand.png": 782,
	"./web-push/web-push-icon_favourite": 783,
	"./web-push/web-push-icon_favourite.png": 783,
	"./web-push/web-push-icon_reblog": 784,
	"./web-push/web-push-icon_reblog.png": 784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 836;